
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class DepartmentBudgetPerformance extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    activeProjectConversionFactor!: number;
    @Prop({ default: () => [] })
    lineSplit!: number;
    @Prop({ default: () => [] })
    disabled!: boolean;
    
    forceReload = 0;

    updateLineSum(departmentId: any, actualCost: any) {
      this.$emit('lineValueChanged', {departmentId, actualCost})
    }

    calculateTotalPlan(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.plan || 0), 0);
    }

    calculateTotalActualCost(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualCost || 0), 0);
    }

    calculateTotalActualDailyCumCost(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualDailyCumulativeCost || 0), 0);
    }

    calculateTotalVarianceCost(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.variance || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
